// ? [REVISIT] manually review this file
import { setCookie, getCookie } from './../utils/cookies';

interface ServerCollectionData {
  metaFields: {
    gender: string;
  };
}

//@ts-ignore
const serverCollectionData: ServerCollectionData | undefined = window.server_collection_data;

class GenderEstimate {
  constructor() {
    this.update();
  }

  getWomenAndMenValues(): [number, number] {
    const genderCookie = getCookie('gndHist');
    if (genderCookie === '' || genderCookie.indexOf('x') === -1) return [0, 0];
    return genderCookie.split('x').map((str) => parseInt(str)) as [number, number];
  }

  get genderCountWomen() {
    return this.getWomenAndMenValues()[0];
  }

  get genderCountMen() {
    return this.getWomenAndMenValues()[1];
  }

  get estimatedGender() {
    const [genderWomenCount, genderMenCount] = this.getWomenAndMenValues();
    const totalCount = genderWomenCount + genderMenCount;
    if ((genderWomenCount * 100) / totalCount >= 60) {
      return 'women';
    }
    if ((genderMenCount * 100) / totalCount >= 60) {
      return 'men';
    }
    return null;
  }

  update() {
    try {
      const setWomenAndMenValues = (women: number, men: number) => {
        setCookie('gndHist', `${women}x${men}`, 365);
      };
      // 0 = women, 1 = men
      const incrementGender = (index: number) => {
        if (index !== 1 && index !== 0) throw new Error('invalid parameter for incrementGender, expecting 0 or 1');
        const values = this.getWomenAndMenValues();
        values[index] = values[index] + 1;
        setWomenAndMenValues(values[0], values[1]);
      };
      const incrementGenderByName = (name: string | null) => {
        if (!name) return null;
        if (name.toLowerCase() === 'women') return incrementGender(0);
        if (name.toLowerCase() === 'men') return incrementGender(1);
      };

      if (serverCollectionData) {
        // (Compatible) collection page
        if (serverCollectionData.metaFields.gender) {
          incrementGenderByName(serverCollectionData.metaFields.gender.toLowerCase().trim());
        }
      } else if (window.server_pdp_data) {
        // (Compatible) product page
        let skuOrHandle;

        if (window.server_pdp_data.product.vendor.toLowerCase() === 'alo yoga set') {
          skuOrHandle = window.server_pdp_data.metaFields?.sets?.colorway_product_handles?.toLowerCase();
        } else {
          skuOrHandle = window.server_pdp_data.sku?.toLowerCase();
        }
        if (skuOrHandle) {
          const productGender = skuOrHandle.startsWith('m', 0)
            ? 'men'
            : skuOrHandle.startsWith('w', 0)
            ? 'women'
            : null;
          incrementGenderByName(productGender);
        }
      }
    } catch (e) {
      if (window.Shopify.theme?.role === 'unpublished') throw e;
    }
  }
}

export default new GenderEstimate();
